import React from "react";
import { InfoRounded } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import useProjectCredits from "@/features/credits/hooks/useProjectCredits";
import CreditsIcon from "@/components/assets/CreditsIcon";

interface CreditsInfoProps {
  title?: string;
  subtitle?: string;
  credits?: number;
  projectId: string;
  isCreatingProject?: boolean;
}

export const CreditsInfo = ({
  title,
  subtitle,
  credits,
  projectId,
  isCreatingProject
}: CreditsInfoProps): React.ReactNode => {
  const _credits = useProjectCredits({
    projectId,
    isCreatingProject
  });

  return (
    <Box
      sx={{
        marginTop: "auto",
        backgroundColor: (theme) => theme.palette.info.hover,
        px: 2,
        py: 1,
        borderRadius: 2
      }}
    >
      <Stack direction={"row"} gap={2} py={0.5} justifyContent={"left"}>
        <Stack justifyContent={"center"} alignItems={"center"}>
          <InfoRounded
            sx={{ height: 20, width: 20, color: "secondary.light" }}
          />
        </Stack>
        <Stack flexGrow={1}>
          <Typography color={"text.primary"} variant="body2" pb={0.25}>
            {title || "Credit consumption per file"}
          </Typography>
          <Typography color={"text.secondary"} variant="caption">
            {subtitle ||
              "Final credit usage will be based on the duration of files in the project."}
          </Typography>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} gap={0.5}>
          <CreditsIcon
            style={{
              height: 20,
              width: 20
            }}
          />
          <Typography variant="subtitle2" color={"text.primary"}>
            {credits || _credits.creditsRate || 0} credits per min
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
